import { formatDistanceToNowStrict } from 'date-fns'

export const capitalizeFirstLetter = (value) => {
    if (!value || typeof value !== 'string') return '-'
    return value.charAt(0).toUpperCase() + value.slice(1)
}

export const formatNotificationTimeAgo = (createdAt) => {
    if (!createdAt) return '-'

    try {
        return formatDistanceToNowStrict(new Date(createdAt), { addSuffix: true })
    } catch (error) {
        return '-'
    }
}

const SUPPORTED_TYPES = ['Task', 'Leave', 'Claim', 'Payroll', 'Attendance']

export const mapNotificationItem = (item) => {
    const mappedType = capitalizeFirstLetter(item?.data?.type)
    const description = item?.data?.message || item?.title || item?.body || '-'

    const isSupportedType = SUPPORTED_TYPES.includes(mappedType)
    const hasValidDescription = description && description !== '-'

    if (!isSupportedType || !hasValidDescription) {
        return null
    }

    return {
        id: item.id,
        type: mappedType,
        description,
        timeAgo: formatNotificationTimeAgo(item.created_at),
        isUnread: !item.is_read,

        raw: item,
        createdAt: item.created_at,
        category: item.category,
        body: item.body,
        detailData: item.data,
    }
}

export const mapNotificationsResponse = (response) => {
    const payload = response?.data || {}

    return {
        items: (payload.items || []).map(mapNotificationItem).filter(Boolean),
        total: payload.total || 0,
        perPage: payload.per_page || 20,
        currentPage: payload.current_page || 1,
        lastPage: payload.last_page || 1,
    }
}